// 部门扩展
import axios from "../axios";


let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
/**
 * 注册
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const registerDeptExtend = (data, params) => {
  return axios({
    url: 'mDeptExtend/registerDeptExtend',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  })
}
/**
 * 专员 注册
 * @param data
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const zyRegisterDeptExtend = (data, params) => {
  return axios(({
    url: 'mDeptExtend/zyRegisterDeptExtend',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  }))
}

/**
 * 查询详情
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendByDeptId = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendByDeptId',
    method: 'post',
    data
  })
}

/**
 * 获取会员注册申请待审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendListOfUnApproval = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListOfUnApproval',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 获取会员注册申请已审核列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendListOfApproved = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListOfApproved',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 审核不通过的会员列表
 * @param data
 * @returns {*|Promise|Promise<unknown>}
 */
export const getDeptExtendListOfApprovalNoPass = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListOfApprovalNoPass',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const getDeptExtendListByCondition = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

/**
 * 通过会员审核申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const approvalDeptExtend = data => {
  return axios({
    url: 'mDeptExtend/approvalDeptExtend',
    method: 'post',
    data
  })
}


/**
 * 驳回会员注册申请
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const rejectDeptExtend = data => {
  return axios({
    url: 'mDeptExtend/rejectDeptExtend',
    method: 'post',
    data
  })
}
/**
 * 查询会员列表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendList = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 * 查询发送短信会员列表
 * @param data
 * @returns {Promise | Promise<unknown>}
 */

export const getDeptExtendListOfMsg = (data) => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListOfMsg',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data

  })
}

export const getAllDeptList = () => {
  return axios({
    url: "mDeptExtend/getAllDeptList",
    method: "post"
  })
}


/**
 * CA登录
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const caLogin = (data, params) => {
  return axios({
    url: 'mDeptExtend/caLogin',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  })
}

/**
 * 根据角色Code查询角色下的用户
 * @param data
 * @param params
 * @returns {*|Promise|Promise<any>}
 */
export const getUserByRoleCodes = (data, params) => {
  return axios({
    url: 'mDeptExtend/getUserByRoleCodes',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: false,//不序列化参数
    data,
    params: params
  })
}

export const getUserByMajorCode = (data, params) => {
  return axios({
    url: 'mDeptExtend/getUserByMajorCode',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: false,//不序列化参数
    data,
    params: params
  })
}

/**
 * 检查统一社会信用代码
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const checkDeptExtendByTyshxydm = (data) => {
  return axios({
    url: 'mDeptExtend/checkDeptExtendByTyshxydm',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    params: data
  })
}

export const downloadApplication = (data) => {
  return axios({
    url: '/mDeptExtend/downloadApplication',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}


/**
 * 保存修改后的信息
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const save = (data, params) => {
  return axios({
    url: 'mDeptExtend/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  })
}

/**
 * 提交修改后的信息
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const submitDeptExtendRecord = (data) => {
  return axios({
    url: 'mDeptExtend/submitDeptExtendRecord',
    method: 'post',
    data,
  })
}

export const saveOrUpdate = (data) => {
  return axios({
    url: 'mDeptExtend/saveOrUpdate',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}


/**
 * 查询会员报表
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const getDeptExtendListReport = data => {
  return axios({
    url: 'mDeptExtend/getDeptExtendListReport',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}

export const downloadDeptExtendListReport = (data, name) => {
  return axios({
    url: '/mDeptExtend/downloadDeptExtendListReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

/**
 * 下载会员单位退会情况表
 * @param data
 * @param name
 * @returns {Promise<T | never>}
 */
export const downloadSignOutReport = (data, name) => {
  return axios({
    url: '/mDeptExtend/downloadSignOutReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

/**
 * 下载党组织情况表
 * @param data
 * @param name
 * @returns {Promise<T | never>}
 */
export const downloadDZZReport = (data, name) => {
  return axios({
    url: '/mDeptExtend/downloadDZZReport',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

/**
 * 保存修改后的信息
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const modifyDeptInfo = (data, params) => {
  return axios({
    url: 'mDeptExtend/modifyDeptInfo',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data,
    params: params
  })
}

export const downloadDeptExtendReportVO = (data, name) => {
  return axios({
    url: '/mDeptExtend/downloadDeptExtendReportVO',
    method: 'post',
    data,
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

/**
 * 检查会员是否已经完成会员注册的审核流程
 * @param data
 * @returns {*|Promise|Promise<any>}
 */
export const checkDeptExtend = () => {
  return axios({
    url: 'mDeptExtend/checkDeptExtend',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
  })
}
export const getFlowApprovalByCondition = data => {
  return axios({
    url: 'mFlowApprova/getFlowApprovalByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/deptExtend.js